// tslint:disable:jsx-no-lambda
// tslint:disable:no-string-literal
import { ColumnDefinition, Cooltip, Cursor, Icon, PagingControl, SORT_STATE, Table, ToggleButton } from '@abb/common-ux';
import { Pill } from '@abb/common-ux/dist/components/Pill/Pill';
import { PillBox } from '@abb/common-ux/dist/components/Pill/PillBox';
import { RequestLogFilterValue } from '@module/analysis/RequestLogFilter';
import RequestLogFilter from '@module/analysis/RequestLogFilter/RequestLogFilter';
import { IRequestReport, ISite } from '@module/shared';
import { FetchRequestLog } from '@service/RequestLogService';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IConnectedComponent, IRequestLogProps } from 'reducers';

export interface IRequestLogState {
  requests: IRequestReport[] | null;
  sortField: string;
  pageSize: number;
  skip: number;
  requestCount: number;
  sortDirection: SORT_STATE;
  showFilter?: boolean;
  searchErrors?: string;
  searchInProgress: boolean;
}

class RequestLogComponent extends React.Component<IConnectedComponent & IRequestLogProps, IRequestLogState> {
  constructor(props: IConnectedComponent & IRequestLogProps) {
    super(props);

    this.state = {
      pageSize: 10,
      skip: this.props.currentPage,
      requestCount: 0,
      requests: null,
      sortField: this.props.sortField,
      sortDirection: this.props.sortDirection,
      searchInProgress: true,
      searchErrors: 'There are no requests that meet the filter criteria.'
    };
  }

  async componentDidUpdate(prevProps: IConnectedComponent & IRequestLogProps) {
    if (this.hasFilterChanged(this.props.filter, prevProps.filter)) {
      this.props.dispatch({ type: 'PAGE_CHANGE', currentPage: 0 });
      await this.getRequestLog();
    }
  }

  async componentDidMount() {
    if (this.props.history.location.state) {
      this.props.history.replace('/requests', null); 
    }
    window.addEventListener('click', this.dismissFilter);
    await this.getRequestLog();
  }

  getRequestLog = async () => {
    const dispatch = this.props.dispatch;
    try {
      const requestObject = { 
        requestFilter: this.props.filter, 
        sortDirection: this.state.sortDirection, 
        sortField: this.state.sortField, 
        pageSize: this.state.pageSize, 
        currentPage: this.state.skip
      };
      const requestLog = await FetchRequestLog(this.props.loggedInUser, requestObject);
      this.setState({ 
        requests: requestLog.requestLogs,
        requestCount: requestLog.totalRecords,
        searchInProgress: false
      });
    } catch (error) {
      if (error.status === 475) {
        dispatch({ type: 'ADD_BANNER', banners: [{ id: 'getRequestLogError', bannerType: 'error', children: <span>You have no permissions to use mySpareParts Analyzer. Try again or contact Customer Support at <a style={{ color: '#0057ff' }} href={`mailto:us-iasvsupport@abb.com?Subject=mySpareParts%20Analyzer,%20Request%20Log%20Error`} target='_top'>us-iasvsupport@abb.com</a>.</span> }] });
      } else {
        dispatch({ type: 'ADD_BANNER', banners: [{ id: 'getRequestLogError', bannerType: 'error', children: <span>Something went wrong and data could not be retrieved. Try again or contact Customer Support at <a style={{ color: '#0057ff' }} href={`mailto:us-iasvsupport@abb.com?Subject=mySpareParts%20Analyzer,%20Request%20Log%20Error`} target='_top'>us-iasvsupport@abb.com</a>.</span> }] });
      }
      console.error(`System error: ${error.status} ${error.statusText}`);
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: 'BANNER_CLEAR' });
    window.removeEventListener('click', this.dismissFilter);
  }

  updateFilter = async (newFilter: RequestLogFilterValue) => {
    this.setState({ skip: 0 });
    this.props.dispatch({ type: 'PAGE_AND_FILTER_CHANGE', filter: newFilter, currentPage: 0 });
  }

  dismissFilter = () => {
    this.setState({ showFilter: false });
  }

  onClosePill = (pillKey: string) => {
    const newFilter = { ...this.props.filter };
    // If pill is country then remove both values from filter
    if (pillKey === 'countryName') {
      newFilter['countryId'] = '';
    }
    newFilter[pillKey] = '';
    this.updateFilter(newFilter);
  }

  clearFilter = () => {
    this.updateFilter(new RequestLogFilterValue());
  }

  onValueChange = (value: string, key: string) => {
    const newFilter = { ...this.props.filter };
    newFilter[key] = value;
    this.updateFilter(newFilter);
  }

  toggleFilter = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ showFilter: !this.state.showFilter });
  }

  stopEventPropogation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.nativeEvent.stopImmediatePropagation();
  }

  changePage = (skip: number) => {
    this.setState({ skip, searchInProgress: true }, () => this.getRequestLog());
    this.props.dispatch({type: 'PAGE_CHANGE', currentPage: skip});
  }

  render() {
    const filterStyle = {
      display: this.state.showFilter ? 'block' : 'none',
    };
    const pillList: JSX.Element[] = [];

    if (this.props.filter !== undefined) {
      Object.keys(this.props.filter).map((keyName) => {
        if (this.props.filter[keyName]) {
          let labelValue: string;
          let value: string;
          switch (keyName) {
            case 'requestID':
              labelValue = 'Request ID';
              break;
            case 'companyName':
              labelValue = 'Company';
              break;
            case 'partsSpecialistName':
              labelValue = 'Parts Specialist';
              break;
            case 'status':
              labelValue = 'Status';
              break;
            case 'countryName':
              labelValue = 'Country';
              break;
            case 'countryId':
              labelValue = 'Country ID';
              break;
            default:
              labelValue = '';
              break;
          }
          value = this.props.filter[keyName];

          // We don't want to display the 'Country ID' Pill since we are showing that as
          // 'Country Name'.

          if (labelValue !== 'Country ID') {
            pillList.push(<Pill key={keyName} id={keyName} label={labelValue} value={value} onClose={this.onClosePill} onClick={() => { console.log(''); }} />);
          }
        }
      });
    }

    const RequestLogColumn = ColumnDefinition as new () => ColumnDefinition<IRequestReport>;
    return (
      <div>
        <div className='row'>
          <div className='col-lg-12'>
            <ol className='breadcrumb breadcrumb_border'>
              <li className='active' id='workOrderId'>Request Log</li>
            </ol>
          </div>
        </div>
        <Cursor cursorSize={2} cursorClassName='cursorStyle'>
          Request Log
        </Cursor>
        <div className='row'>
          <div className='col-sm-8'>
            <div className='row' style={{ marginLeft: '1px' }}>
              <PillBox>
                {pillList}
              </PillBox>
            </div>
          </div>
          <div className='col-sm-4 text-right filterAndPaginationContainer'>
            <span className='requestCountText'>{this.state.requestCount} Requests</span>
            <PagingControl pageRequested={this.changePage} top={this.state.pageSize} skip={this.state.skip} totalItemCount={this.state.requestCount === 0 ? 1 : this.state.requestCount} />
            <ToggleButton className='filterButton' isToggled={this.state.showFilter} buttonSize='default' buttonType='normal' icon='filter' id='seFilterBtn' onClick={this.toggleFilter} />
          </div>
          <div className='filter' id='offeringFilter' style={filterStyle} onClick={this.stopEventPropogation}>
            <RequestLogFilter filter={this.props.filter} onFilterApply={this.updateFilter} onClear={this.clearFilter} onFilterValueChange={this.onValueChange} loggedInUser={this.props.loggedInUser} />
          </div>
        </div>
        <br />
        <div className='row'>
          <div className='col-lg-12' >
            <Table isLoading={this.state.searchInProgress}
              emptyMessage={this.state.searchErrors}
              navigateColumn={this.displayRequestDetails}
              data={this.state.requests ? this.state.requests : []}
              sortedColumnName={this.state.sortField}
              sortedColDirection={this.state.sortDirection}
              headerClick={this.sortColumn}
              fixedHeader={true}
            >
              <RequestLogColumn
                cell={row => row.requestID.toString()}
                header='REQUEST ID'
                columnName='requestID'
                columnWidth={1}
              />
              <RequestLogColumn
                cell={row => moment(row.createdAt).format('MM/DD/YYYY HH:mm:ss')}
                header='UPLOAD DATE'
                columnName='uploadDate'
                columnWidth={1}
              />
              <RequestLogColumn
                cell={row => row.contactEmail}
                header='EMAIL ADDRESS'
                columnName='contactEmail'
                columnWidth={2}
              />
              <RequestLogColumn
                cell={row => row.companyName}
                header='COMPANY'
                columnName='companyName'
                columnWidth={2}
              />
              <RequestLogColumn
                cell={row => row.country}
                header='COUNTRY'
                columnName='country'
                columnWidth={1}
              />
              <RequestLogColumn
                cell={this.renderLeadGenerationColumn}
                header='LEAD GENERATED'
                columnName='leadGenerated'
                columnWidth={1}
              />
              <RequestLogColumn
                cell={row => row.partsSpecialistName}
                header='PARTS SPECIALIST'
                columnName='partsSpecialistName'
                columnWidth={1}
              />
              <RequestLogColumn
                cell={this.renderSiteAssignedColumn}
                header='SITE ASSIGNED'
                columnName='associatedSite'
                columnWidth={1}
              />
              <RequestLogColumn
                cell={this.renderPartsManagerLink}
                header='mSP Manager'
                columnName='serviceProSiteId'
                columnWidth={1}
              />
              <RequestLogColumn
                cell={this.renderStatusColumn}
                header='STATUS'
                columnName='status'
                columnWidth={1}
              />
            </Table>
          </div>
        </div>
      </div>
    );
  }

  renderLeadGenerationColumn = (request: IRequestReport) => {
    return <div><Icon icon='check_mark_circle2' size='small' color='green' visibility={request.leadGenerated ? 'visible' : 'hidden'} /><span>{request.leadGenerated ? ' Yes' : ' No'}</span></div>;
  }

  renderSiteAssignedColumn = (request: IRequestReport) => {
    return <div><Icon icon='check_mark_circle2' size='small' color='green' visibility={request.associatedSite ? 'visible' : 'hidden'} /><span>{request.associatedSite ? ' Yes' : ' No'}</span></div>;
  }

  renderPartsManagerLink = (request: IRequestReport) => {
    return request.associatedSite
      ? <a target='_blank' href={`${environmentSettings.partsManagerUrl}/Site/${JSON.parse(request.associatedSite).ServIsId}`}>Link</a>
      : '-';
  }

  renderStatusColumn = (request: IRequestReport) => {
    const comments: string = request.comments ? request.comments.trim() : '';
    return (
      (request.status === 'Pending' && this.calculateDateDiff(request.createdAt) >= 48)
        ? <div><span><Icon icon='warning_triangle' color='orange' size='small' />{'  '}Pending</span></div>
        : (request.status === 'Pending' && this.calculateDateDiff(request.createdAt) < 48)
          ? <div><span><Icon icon='hourglass' color='green' size='small' />{'  '}Pending</span></div>
          : (
            <div>
              <span>
                <Cooltip tooltipType='default' tooltipContents={<span>{request.comments}</span>} hidden={comments ? false : true} placement='topLeft' >
                  <span><Icon icon='information_circle2' color='#87d2ff' visibility={comments ? 'visible' : 'hidden'}/></span>
                </Cooltip>
                {'  '}{request.status}
              </span>
            </div>
            )
    );
  }

  sortColumn = (sortByFieldName: string) => {
      let newSortField: string = this.state.sortField;
      let newSortDirection: SORT_STATE = this.state.sortDirection;

      if (sortByFieldName) {
        if (this.state.sortField === sortByFieldName) {
          newSortDirection = this.state.sortDirection === 'asc' ? 'desc' : 'asc';
        } else if (sortByFieldName === 'requestID' || sortByFieldName === 'serviceProSiteId') {
          newSortField = sortByFieldName;
          newSortDirection = 'desc';
        } else {
          newSortField = sortByFieldName;
          newSortDirection = 'asc';
        }
        this.props.dispatch({ type: 'SORT_CHANGE', sortField: newSortField, sortDirection: newSortDirection });
        this.setState({ sortField: newSortField, sortDirection: newSortDirection, searchInProgress: true }, () => this.getRequestLog());
      }
  }

  calculateDateDiff(uploadDate: Date): number {
    return moment.duration(moment(new Date()).diff(uploadDate)).asHours();
  }

  //Displaying Request Details onClick
  displayRequestDetails = (requestParam: IRequestReport) => {
    this.props.history.push('/requests/' + requestParam.sparePartsUploadDetailsID);
  }

  hasFilterChanged(curFilter: RequestLogFilterValue, prevFilter: RequestLogFilterValue) {
    return curFilter.companyName !== prevFilter.companyName ||
      curFilter.countryId !== prevFilter.countryId ||
      curFilter.countryName !== prevFilter.countryName ||
      curFilter.partsSpecialistName !== prevFilter.partsSpecialistName ||
      curFilter.requestID !== prevFilter.requestID ||
      curFilter.status !== prevFilter.status;
  }

}

export const RequestLog = withRouter(connect(mapStateToProps)(RequestLogComponent) as any);

function mapStateToProps(store: any) {
  return {
    loggedInUser: store.userState.loggedInUser,
    filter: store.requestLogState.filter,
    currentPage: store.requestLogState.currentPage,
    sortField: store.requestLogState.sortField,
    sortDirection: store.requestLogState.sortDirection
  };
}
